import React, { createContext, useContext } from "react";

export const EMAIL_BUILDER_SETTINGS_DEFAULT_OVERLAY_PORTAL_ID = "portal-root";
export const EMAIL_BUILDER_SETTINGS_SHEET_OVERLAY_PORTAL_ID =
  "email-builder-settings-sheet-overlays";

const EmailBuilderSettingsOverlayPortalContext = createContext<string>(
  EMAIL_BUILDER_SETTINGS_DEFAULT_OVERLAY_PORTAL_ID,
);

export function EmailBuilderSettingsOverlayPortalProvider(props: {
  portalId: string;
  children: React.ReactNode;
}) {
  return (
    <EmailBuilderSettingsOverlayPortalContext.Provider value={props.portalId}>
      {props.children}
    </EmailBuilderSettingsOverlayPortalContext.Provider>
  );
}

export function useEmailBuilderSettingsOverlayPortalId(): string {
  return useContext(EmailBuilderSettingsOverlayPortalContext);
}
